import { ServiceRequestBase } from "../ServiceRequestBase";

export class UpdatePasswordRequest extends ServiceRequestBase {
  public NewPassword: string = '';
  public EmailAddress: string = '';
}
